var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',[_c('LeftMenu',{on:{"loadList":_vm.loadList}}),_c('MypageContainer',{attrs:{"listType":_vm.listType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }